<template>
  <div class="ui container view">
    <div class="ui vertically divided grid">
      <div class="two column row">
        <div class="ten wide column">
          <table class="ui compact celled table">
            <thead>
              <th colspan="7">Estimate Components</th>
            </thead>
            <quote-component
              v-for="component in quoteAggregates.components"
              :component="component"
              :quote-params="quoteParams"
            />
          </table>
        </div>
        <div class="six wide column">
          <table class="ui compact celled table">
            <thead>
              <th colspan="2">Fixed Cost Items</th>
            </thead>
            <tbody>
              <tr v-for="item in quoteAggregates.fixed_cost_items">
                <td>{{ item.title }}</td>
                <td class="right aligned">{{ item.amount | currency }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="total">
                <th>Total</th>
                <th class="right aligned">{{ quoteAggregates.fixed_cost_items_amount | currency }}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import QuoteComponent from './QuoteComponent.vue'

export default {
  data () {
    return {
      quoteParams: {},
      quoteAggregates: {}
    }
  },

  components: {
    QuoteComponent
  },

  methods: {
    initSummary () {
      this.quoteParams = this.$store.getters.params
      this.quoteAggregates = this.$store.getters.aggregates
    },

    componentAggregates (title) {
      return _.find(this.quoteAggregates.components, ['title', title])
    }
  },

  created () {
    if (this.$store.getters.quoteIsLoaded) {
      this.initSummary()
    } else {
      console.log('Quote not yet loaded. Redirecting...')
      this.$router.replace({ name: 'new' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .ui.table tr.total th {
    background-color: #646464;
    color: #f0f0f0;
    font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// Summary.vue?3f5de446